import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import images from "../../constants/images";

import "./About.scss";
import { client, urlFor } from "../../client";
import AppWrap from "../../wrapper/AppWrap/AppWrap";

const About = () => {
  const [about, setAbout] = useState([]);
  const abouts = [
    {
      title: "Front-End Developer",
      describtion: "Good skills about Front End Development",
      imgurl: images.about01,
    },
    {
      title: "Back-End Developer",
      describtion: "Good skills about Back End Development",
      imgurl: images.about02,
    },
    {
      title: "Computer skills",
      describtion: "Good skills about Front End Development",
      imgurl: images.about03,
    },
    {
      title: "Nerd Developer",
      describtion: "Interested about Computer World",
      imgurl: images.about04,
    },
    {
      title: "Computer science",
      describtion: "Build Hight Performance Apps",
      imgurl: images.about01,
    },
  ];

  useEffect(() => {
    const query = '*[_type=="abouts" ]';
    client.fetch(query).then((data) => setAbout(data));
  }, []);

  return (
    <div className="app__about">
      <div className="app__about-head head-text">
        <h3>
          Build your dream <span>apps</span>
        </h3>
        <h4>
          Good deal, <span>good business</span>
        </h4>
      </div>
      <div className="app__about-skills">
        {about.map((about, id) => (
          <motion.div
            key={`about-${id}`}
            whileInView={{ opacity: [0, 1] }}
            whileHover={{ scale: [1, 1.05] }}
            className="about-skill"
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text">{about.title}</h2>
            <p className="p-text">{about.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AppWrap(About, "about", "app__whitebg");
